import { AgTechButtonProps, AgTechButton, AgTechActionButton } from '@agtech/web/components/Buttons/AgTechButtons';
import { SaleDiscount } from '@sales/data/sales/discounts/SaleDiscountData';
import { useSaleDiscountDataDeleteDiscountAction } from '@sales/data/sales/discounts/SaleDiscountDataActions';
import React from 'react'
import SaleDiscountActionMenu from '../menus/SaleDiscountActionMenu';

export type SaleDiscountRemovalButtonProps = AgTechButtonProps & {
    discount: SaleDiscount
}

export const SaleDiscountRemovalButton = (props: SaleDiscountRemovalButtonProps) => {
    let deleteDiscountAction = useSaleDiscountDataDeleteDiscountAction();

    let buttonProps: AgTechButtonProps = {
        ...props,
        action: e => e.actions.executeDataActionInModal(deleteDiscountAction, {
            submittedEntity: props.discount
        })
    };

    buttonProps.text = buttonProps.text ? buttonProps.text : 'Delete';
    buttonProps.icon = buttonProps.icon ? buttonProps.icon : 'fas fa-times';

    return <AgTechButton {...buttonProps} />
}

export type SaleDiscountActionButtonProps = {
    discount: SaleDiscount
}

export const SaleDiscountActionButton = (props: SaleDiscountActionButtonProps) => {
    return (
        <AgTechActionButton>
            <SaleDiscountActionMenu discount={props.discount} />
        </AgTechActionButton>
    )
}